import { color } from "framer-motion";
import React, { useState } from "react";
import { Row } from "react-bootstrap";
import chevronRight from "../../../assets/images/chevron-right.png";
const StaticRoles = () => {
  // ✅ toutes les sections sont ouvertes au départ
  const [openSections, setOpenSections] = useState([0, 1, 2, 3]);

  const toggleOpen = (index) => {
    setOpenSections((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index) // refermer si déjà ouvert
        : [...prev, index] // ouvrir si fermé
    );
  };

  // ✅ données statiques
  const sections = [
    {
      title: "Gestion des utilisateurs",
      users: ["Modifier un utilisateur", "Supprimer un utilisateur","Créer un utilisateur"],
    },
    {
      title: "Gestion des opérations",
      users: ["Faire un transfert", "Faire une demande de reversement","Supprimer un opérateur"],
    },
    {
      title: "Gestion des transactions",
      users: ["Voir les transactions", "Effectuer une recherche et/ou filtre"],
    },
    {
      title: "Affichages",
      users: ["Consulter le dashboard", "Consulter le profil","Consulter la gestion des rôles","Consulter paiement de masse","Consulter lien de paiement","Consulter collecte","Consulter l’API"],
    },
  ];

  return (
    <Row>
      <div className="mt-5 px-3">
        <div>
          {sections.map((section, index) => (
            <div
              key={index}
              className=""
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: 757,
              }}
            >
              {/* Header de la section */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #E3E3E3",
                  height: "40px",
                  overflow: "hidden",
                  padding: "0 8px",
                  gap: "8px",
                  cursor: "pointer",
                }}
                onClick={() => toggleOpen(index)}
              >
                <span
                  style={{
                    flex: "1",
                    fontFamily: "Poppins",
                    fontSize: "20px",
                    fontWeight: "500",
                    color: "#070707",
                  }}
                >
                  {section.title}
                </span>
                <img
                 src={chevronRight}
                  alt="chevron"
                  style={{
                    width: "22px",
                    height: "22px",
                    transform: openSections.includes(index)
                      ? "rotate(90deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.2s ease",
                  }}
                />
              </div>

              {/* Contenu déroulant */}
              {openSections.includes(index) && (
                <div
                  style={{
                    marginBottom: "12px",
                    padding: "6px 8px",
                    backgroundColor: "#fff",
                    border: "1px solid #E3E3E3",
                    width: "100%",
                  }}
                ><span style={{color:"#141414",fontSize:'18px',fontFamily:'Poppins',fontWeight:400}}>Il peut :</span>
                  {section.users.map((user, i) => (
                    <div
                      key={i}
                      style={{
                        padding: "6px 0",
                        fontFamily: "Poppins",
                        fontSize: "16px",
                        fontWeight:400,
                        color:'#141414'
                      }}
                    >
                     <li style={{marginLeft:'20px'}}>{user}</li>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </Row>
  );
};

export default StaticRoles;
